import { langServerClient } from '@/shared/api/langserver';
import { createDemoBuildResponse, shouldUseDemoBuild } from '@/shared/api/langserver/demo';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { BuildRequest, BuildResponse } from './types';

export async function fetchBuild(target: ModuleTarget = 'run', request: BuildRequest): Promise<BuildResponse> {
  if (shouldUseDemoBuild(target)) {
    return createDemoBuildResponse(request);
  }

  const response = await langServerClient.post<BuildResponse>(`/${target}/api/v1/analysis/build`, {
    clientId: request.clientId,
    template: request.template,
    autoImports: request.autoImports,
  });

  return response.data;
}
